<div class="container mt-4">
<div class="card">
    <div class="card-header">
        <h5 class="card-title m-0">Contact Us</h5>
    </div>
    <div class="card-body">
        <p>If you want to have any information about Department, please contact the <b>Web Information Manager: Deputy Registrar (Consumer)</b>.</p>

        <div class="row">
            <div class="col-lg-6">
                <div class="table-responsive">
                    <table class="table table-condensed table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Designation</th>
                                <th>Email Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Registrar Cooperative Societies</td>
                                <td><a href="mailto:rcs-hp@nic.in" class="link-color">rcs-hp&#64;nic.in</a></td>
                            </tr>
                            <tr>
                                <td>Additional Registrar (Administration)</td>
                                <td><a href="mailto:adrcs-adm-hp@nic.in" class="link-color">adrcs-adm-hp&#64;nic.in</a></td>
                            </tr>
                            <tr>
                                <td>Additional Registrar (Monitoring)</td>
                                <td><a href="mailto:adrcsmon-hp@nic.in" class="link-color">adrcsmon-hp&#64;nic.in</a></td>
                            </tr>
                            <tr>
                                <td>Joint Registrar (Credit)</td>
                                <td><a href="mailto:jrcredit-hp@nic.in" class="link-color">jrcredit-hp&#64;nic.in</a></td>
                            </tr>
                            <tr>
                                <td>Deputy Registrar (Audit)</td>
                                <td><a href="mailto:draudit-hp@nic.in" class="link-color">draudit-hp&#64;nic.in</a></td>
                            </tr>
                            <tr>
                                <td>Assistant Registrar (Audit)</td>
                                <td><a href="mailto:araudit-hp@nic.in" class="link-color">araudit-hp&#64;nic.in</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-lg-6">
                <h6>Address</h6>
                <p class="m-0">Directorate of Cooperation</p>
                <p class="m-0">Sahkaar Bhawan, Block No. 25, SDA Complex,</p>
                <p class="m-0">Kasumpti, Shimla-171009, Himachal Pradesh</p>
                <p class="m-0">Phone : 0177-2620970 , 2620722 , 2620937</p>
                <p class="m-0">Fax : 0177-2621443</p>
            </div>
        </div>
    </div>    
</div>
</div>